import { Avatar, Badge, Box, Icon, Text } from '@factorialco/deprecated-design-system'

import Popover from 'modules/core/components/PopoverMenu'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { useShareTaskProvider } from 'modules/tasks/components/TaskDetails/Header/Share/Provider'

interface Props {
  disabled?: boolean
  type: 'author' | 'assignees' | 'shared'
  name: string
  jobTitle?: string | null
  avatar?: string | null
  badge?: React.ComponentProps<typeof Icon.Large>['icon']
  accessId?: string
}

export const Employee = ({ disabled, type, name, jobTitle, avatar, badge, accessId }: Props) => {
  const { removeAccess } = useShareTaskProvider()

  const FakeSelect = () => {
    const visibilityText = () => {
      switch (type) {
        case 'author':
          return i18n.t('tasks.share.modal.employees.visibility.owner')
        case 'assignees':
          return i18n.t('tasks.share.modal.employees.visibility.editor')
        default:
          return i18n.t('tasks.share.modal.employees.visibility.commenter')
      }
    }

    return (
      <Box
        alignItems="center"
        paddingX="s12"
        border={{ all: { width: 's2', style: 'solid', color: 'grey400' } }}
        borderRadius={{ all: 'abs008' }}
        {...(disabled && { background: 'grey200', cursor: 'default' })}
      >
        <Box
          minWidth="s140"
          minHeight="s40"
          flexDirection="row"
          justifyContent="spaceBetween"
          alignItems="center"
          paddingLeft="s4"
        >
          <Text.Normal color="grey1000">{visibilityText()}</Text.Normal>

          <Icon.Small icon="caret-down" />
        </Box>
      </Box>
    )
  }

  return (
    <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
      <Box flexDirection="row" gap="s8" alignItems="center">
        {badge && (
          <Badge color="grey200" size="s32">
            <Icon.Large icon={badge} color="grey800" />
          </Badge>
        )}

        {avatar && <Avatar size="s32" url={buildUrl(avatar)} label={name} />}

        {!badge && !avatar && (
          <Badge color="grey200" size="s32">
            <Icon.Large icon="user" color="grey800" />
          </Badge>
        )}
        <Box>
          <Text.Normal weight="medium" color="grey1000">
            {name}
          </Text.Normal>
          <Text.Normal size="200" color="grey800">
            {jobTitle}
          </Text.Normal>
        </Box>
      </Box>
      <Popover type="list">
        {disabled ? (
          <FakeSelect />
        ) : (
          accessId && (
            <Popover.Trigger>
              <FakeSelect />
            </Popover.Trigger>
          )
        )}
        {accessId && (
          <Popover.Content side="bottom" align="start">
            <Popover.TouchableOption
              danger
              title={i18n.t('tasks.share.modal.employees.options.remove.title')}
              description={i18n.t('tasks.share.modal.employees.options.remove.description')}
              onClick={() => {
                removeAccess(accessId)
              }}
            />
          </Popover.Content>
        )}
      </Popover>
    </Box>
  )
}
